<template>
  <component
    :is="getMediaType(file.properties)"
    :file="file"
    :media-label="mediaLabel"
  />
</template>
<script>
import MediaYoutube from 'nuxt-typo3/lib/templates/components/content/elements/media/type/Youtube';
import MediaVimeo from 'nuxt-typo3/lib/templates/components/content/elements/media/type/Vimeo';
import MediaVideo from 'nuxt-typo3/lib/templates/components/content/elements/media/type/Video';
import MediaAudio from 'nuxt-typo3/lib/templates/components/content/elements/media/type/Audio';
/* We need THIS file to overwrite the following file */
import MediaImage from './type/CustomImage';
export default {
  name: 'MediaFile',
  components: {
    MediaImage,
    MediaYoutube,
    MediaVimeo,
    MediaVideo,
    MediaAudio
  },
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    },
    mediaLabel: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    getMediaType(file) {
      switch (file.type) {
        case 'video': {
          if (file.mimeType.includes('youtube')) {
            return 'media-youtube';
          }
          if (file.mimeType.includes('vimeo')) {
            return 'media-vimeo';
          }
          return 'media-video';
        }
        case 'audio':
          return 'media-audio';
        default:
          return 'media-image';
      }
    }
  }
};
</script>
